import * as z from "zod";
import { gql } from "graphql-request";
import { SysSchema, SysFragment } from "./sys";

export const UnifiedButtonSchema = z.object({
  sys: SysSchema,
  __typename: z.literal("UnifiedButton"),
  buttonText: z.string().nullable(),
  buttonColorVariant: z.string().nullable(),
  buttonTarget: z
    .discriminatedUnion("type", [
      z.object({
        type: z.literal("customUrl"),
        configuration: z.object({ url: z.string().optional() }),
      }),
      z.object({
        type: z.literal("inboxArticle"),
        configuration: z.object({ articleId: z.string().optional() }),
      }),
      z.object({
        type: z.literal("inboxPoll"),
        configuration: z.object({ articleId: z.string().optional() }),
      }),
      z.object({
        type: z.literal("ingameStore"),
      }),
      z.object({
        type: z.literal("makeSso"),
        configuration: z.object({ url: z.string().optional() }).nullish(),
      }),
      z.object({
        type: z.literal("eventPlatform"),
      }),

      // Deprecated (but we still have this type of content, so we need to support it)
      z.object({
        type: z.literal("make"),
        configuration: z.object({ url: z.string().optional() }).nullish(),
      }),
    ])
    .nullable(),
});

export const UnifiedButton = UnifiedButtonSchema;
export type UnifiedButton = z.infer<typeof UnifiedButtonSchema>;

export const UnifiedButtonFragment = gql`
  fragment UnifiedButtonFragment on UnifiedButton {
    sys {
      ...SysFragment
    }
    __typename
    buttonText
    buttonColorVariant
    buttonTarget
  }

  ${SysFragment}
`;
